import { useEffect, useRef, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import chatService from '../../../services/chat.service';

const TIME_BEFORE_DELETE = 5000;

export function useSoftDeletedChat({ onCallBackDeleted, onHide, onRestore }) {
  const axiosPrivate = useAxiosPrivate();

  const [isShowingDelete, setIsShowingDelete] = useState(false);
  const [deletingCounter, setDeletingCounter] = useState(TIME_BEFORE_DELETE / 1000);
  const deleteTimeoutRef = useRef(null);
  const lastDeletedChatIdRef = useRef(null);

  const lastDeletedChatId = lastDeletedChatIdRef.current;

  useEffect(() => {
    if (isShowingDelete) {
      const timerInterval = setInterval(() => setDeletingCounter((prev) => prev === 0 ? 0 : prev - 1), 1000);
      return () => clearInterval(timerInterval);
    }
  }, [isShowingDelete]);

  const onDeleteChat = (chatId, callback) => {
    onHide?.(chatId);
    lastDeletedChatIdRef.current = chatId;

    setIsShowingDelete(true);
    setDeletingCounter(TIME_BEFORE_DELETE / 1000);

    deleteTimeoutRef.current = setTimeout(async () => {
      await chatService.deleteChatSoft(axiosPrivate, chatId);
      onCallBackDeleted?.(chatId);
      setIsShowingDelete(false);
      setDeletingCounter(TIME_BEFORE_DELETE / 1000);
      if (callback) callback();
    }, TIME_BEFORE_DELETE);
  };

  const onUndoDelete = () => {
    if (deleteTimeoutRef.current) {
      clearTimeout(deleteTimeoutRef.current);
      deleteTimeoutRef.current = null;
    }
    onRestore?.(lastDeletedChatId);

    setIsShowingDelete(false);
    setDeletingCounter(TIME_BEFORE_DELETE / 1000);
  };

  return {
    onDeleteChat,
    ToastDeleting: () => {
      return (
        isShowingDelete && (
          <div className="flex items-center gap-3 text-white bg-[#010D0D] rounded-lg px-4 py-2 fixed left-0 right-0 bottom-[90px] m-4 z-[10]">
            <div
              className="size-[32px] rounded-full flex items-center justify-center text-white"
              style={{
                background: `conic-gradient(white ${deletingCounter * 72}deg, transparent 0)`,
              }}
            >
              <p className="bg-[#010D0D] size-[27px] font-semibold text-base rounded-full flex items-center justify-center">
                {deletingCounter}
              </p>
            </div>
            <p className="text-base">Чат удалён</p>
            <button className="text-[#A1F69E] text-base ml-auto" onClick={onUndoDelete}>
              Отмена
            </button>
          </div>
        )
      );
    },
  };
}
